import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CompareArrows, ShoppingBasket } from '@mui/icons-material';
import { getOperationById, getShareholders } from 'services/network/api/postinvest';
import DashboardWalletData from '../../DashboardWalletData';
import styles from './DashboardWalletSocietyHistory.module.css';
import { logError } from 'utils/logs';
export default function DashboardWalletSocietyHistory({ societyId, iss }) {
    const [status, setStatus] = useState('IDLE');
    const [data, setData] = useState();
    const { t } = useTranslation();
    useEffect(() => {
        const getHistory = async () => {
            var _a;
            setStatus('LOADING');
            try {
                const { data: shareholders } = await getShareholders(societyId);
                let sharesHistory = ((_a = shareholders === null || shareholders === void 0 ? void 0 : shareholders.shareholders.find((shareholder) => shareholder.iss === iss)) === null || _a === void 0 ? void 0 : _a.history) || [];
                const operationsResponse = await Promise.all(sharesHistory.map((history) => getOperationById(societyId, history.operations[0])));
                sharesHistory = sharesHistory.map((history, key) => {
                    var _a, _b, _c, _d, _e, _f;
                    return (Object.assign(Object.assign({}, history), { status: (_b = (_a = operationsResponse[key]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.status, type: (_d = (_c = operationsResponse[key]) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.type, quantity: (_f = (_e = operationsResponse[key]) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.quantity }));
                });
                setStatus('SUCCESS');
                setData(sharesHistory);
            }
            catch (err) {
                logError(err);
                console.error('[ERROR]: ', err);
                setStatus('ERROR');
            }
        };
        if (status === 'IDLE') {
            getHistory();
        }
    }, []);
    const ICON = {
        reduction: _jsx(ShoppingBasket, {}),
        cession: _jsx(CompareArrows, {}),
        souscription: _jsx(ShoppingBasket, {}),
    };
    const TYPE = {
        reduction: t('dashboard.wallet.history.buy'),
        cession: t('dashboard.wallet.history.transfer'),
        souscription: t('dashboard.wallet.history.buy'),
    };
    if (status !== 'SUCCESS')
        return null;
    return (_jsxs("section", { className: styles.history, children: [_jsx("h3", { className: styles.title, children: t('dashboard.wallet.history.title') }), data === null || data === void 0 ? void 0 : data.map((history) => (_jsxs("div", { className: styles.item, children: [_jsx(DashboardWalletData, { icon: ICON[history.type], data: history.date, label: TYPE[history.type], reversedStyle: true }), _jsxs("div", { className: styles.text, children: [_jsx("p", { className: styles.shares, children: t('dashboard.wallet.history.shares', { shares: history.buy || history.quantity }) }), _jsx("p", { className: styles.status, children: history.status })] })] }, history.id)))] }));
}
